/*
 * @Descripttion: 路由
 * @version: 1
 * @Author:
 * @Date: 2019-08-07 17:20:40
 * @LastEditors: lzq
 * @LastEditTime: 2023-11-08 11:43:03
 */
import Vue from 'vue'
import Router from 'vue-router'
import store from './store'
import NProgress from 'nprogress'
import { getToken } from './utils/auth'
import { Notification, MessageBox, Message } from 'element-ui'
import Layout from '@/components/Container.vue'
import 'nprogress/nprogress.css'
// 进入路由动画配置
NProgress.inc(0.2)
NProgress.configure({
  ease: 'line',
  speed: 500,
  showSpinner: false,
  minimum: 0.3,
})
const originalPush = Router.prototype.push

Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

Vue.use(Router)
const constantRoutes = [
  {
    path: '/',
    component: Layout,
    redirect: '/index',
    name: '首页',
    meta: {
      title: '首页',
      icon: 'menu-icon1'
    },
    children: [  ]
  },
  {
    path: '/index',
    component: Layout,
    redirect: '/statistics',
    name: '统计',
    meta: {
      title: '统计',
      icon: 'menu-icon1'
    },
    children: [  ]
  },
  {
    // 本地,测试环境登录地址
    path: '/temp',
    component: (resolve) => require(['@/views/home/Temp.vue'], resolve),
  }, {
    path: '/404',
    component: () => import('@/views/errorPage/404.vue'),
    hidden: true
  }
]

const router = new Router({
  mode: 'hash',
  base: process.env.VUE_APP_CONTEXT_PATH,
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRoutes
})

/**
 * 重写路由的push方法
 */
const routerPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return routerPush.call(this, location).catch((error) => {
    console.error(error)
  })
}
const whiteList = ['/temp']

router.beforeEach(async (to, from, next) => {
  NProgress.start()
  const hasToken = getToken()
  if (hasToken) {
    if (to.path === '/temp') {
      next({ path: '/' })
      NProgress.done() // hack: https://github.com/PanJiaChen/vue-element-admin/pull/2939
    } else {
      // determine whether the user has obtained his permission roles through getInfo
      const userInfo = store.state.user.userInfo
      if (userInfo) {
        next()
      } else {
        try {
          // 判断当前用户是否已拉取完user_info信息
          await store.dispatch('GetInfo')
          await store.dispatch('GetPermissions')
          store.dispatch('GenerateRoutes').then((accessRoutes) => {
            router.addRoutes(accessRoutes) // 动态添加可访问路由表
            next({ ...to, replace: true }) // hack方法 确保addRoutes已完成
          })
        } catch (error) {
          // remove token and go to login page to re-login
          await store.dispatch('user/resetToken')
          Message.error(error || 'Has Error')
          next()
          NProgress.done()
        }
      }
    }
  } else {
    if (whiteList.indexOf(to.path) !== -1) {
      next()
    } else {
      // other pages that do not have permission to access are redirected to the login page.
      next(`/temp`)
      NProgress.done()
    }
  }

})

router.afterEach(() => {
  NProgress.done()
})
export default router
export { constantRoutes }
